import SignupForm from "../Component/Account/Signup";
import Layout from "../Layout/Layout";

const SignupPage = () => {
	return (
		<Layout>
			<SignupForm />
		</Layout>
	);
};

export default SignupPage;
